import { FiInfo } from "../../assets/icons/vander";
import { ValorationPatientAssessmentMade } from "./";

export const ResultValorationPatient = ({
  id,
  state,
  numberEvents,
  protocol,
  clearanceStatus,
  clearanceNote,
}) => {
  // Datos del hook ----------------------------------------//

  // States ------------------------------------------------//

  // Formulario --------------------------------------------//

  // Funciones ---------------------------------------------//

  // Efectos -----------------------------------------------//
  return (
    <>
      {state === "ASSESSMENT_MADE" ||
      state === "ASSESSMENT_MADE_RESCHEDULE" ||
      state === "QUIZ_SATISFACTION_ANSWERED" ||
      state === "SCHEDULED_ASSESSMENT_FINAL" ||
      state === "FINISHED" ? (
        <ValorationPatientAssessmentMade
          numberEvents={numberEvents}
          protocol={protocol}
          clearanceStatus={clearanceStatus}
          clearanceNote={clearanceNote}
        />
      ) : (
        <div className="alert bg-soft-yellow fw-medium" role="alert">
          <FiInfo className="fs-5 align-middle me-1" /> El paciente no presenta
          valoración
        </div>
      )}
    </>
  );
};
